import type { Student } from '@/systems/StudentService';

/**
 * ActiveStudent — qual aluno está jogando agora.
 *
 * Persistido em localStorage pra sobreviver F5 e fechamentos do
 * navegador (UX: quem deixou aberto e voltou no dia seguinte não
 * perde o estado). É limpo explicitamente no signOut e quando o pai
 * "trocar aluno" deliberadamente.
 *
 * Convive com o que o Supabase já guarda da sessão de auth — separado
 * de propósito: a sessão do pai é nível "conta", o aluno ativo é nível
 * "perfil dentro da conta".
 */

const STORAGE_KEY = 'tabuadageek:active-student';

let cached: Student | null | undefined; // undefined = ainda não hidratado

export function getActiveStudent(): Student | null {
  if (cached !== undefined) return cached;
  cached = readFromStorage();
  return cached;
}

export function setActiveStudent(student: Student | null): void {
  cached = student;
  try {
    if (student) localStorage.setItem(STORAGE_KEY, JSON.stringify(student));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ambientes sem localStorage (SSR/sandbox): cache em memória já reflete.
  }
}

function readFromStorage(): Student | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Student;
    if (typeof parsed?.id !== 'string' || typeof parsed?.displayName !== 'string') return null;
    return parsed;
  } catch {
    return null;
  }
}
